import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPersonalDetails } from 'API/personalDetails';

export interface IPersonalDetailsState {
  personalDetails: IPersonalDetails | null;
}

const initialState: IPersonalDetailsState = {
  personalDetails: null,
};

export const personalDetailsSlice = createSlice({
  name: 'personal-details',
  initialState,
  reducers: {
    setPersonalDetails: (
      state: IPersonalDetailsState,
      action: PayloadAction<any>
    ) => {
      state.personalDetails = action.payload;
    },
  },
});

export const { setPersonalDetails } = personalDetailsSlice.actions;

export default personalDetailsSlice.reducer;
